import React from "react";
import { Create } from "react-admin";
import { UserForm } from "./UserForm";

export const UserCreate = (props) => (
  <Create title="Criar Usuário" {...props}>
    <UserForm {...props} />
  </Create>
);
